"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["handleSubmit", "submit", "disabled"];

function Component(_ref) {
  var handleSubmit = _ref.handleSubmit,
      submit = _ref.submit,
      disabled = _ref.disabled,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var dispatch = (0, _reactRedux.useDispatch)();
    var submitButtonClassName = (0, _classnames["default"])(_defaultModule["default"]['submit'], 'icon-success');
    return /*#__PURE__*/_react["default"].createElement("form", {
      "data-locator": props['data-locator'] + '.apply.form',
      className: _defaultModule["default"]['form'],
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      "data-locator": props['data-locator'] + '.apply.form.amount',
      label: "\u0421\u0443\u043C\u043C\u0430 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F",
      name: "amount",
      disabled: disabled
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['control']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": props['data-locator'] + '.apply.form.submit',
      className: submitButtonClassName,
      onClick: function onClick() {
        return dispatch(submit());
      }
    })));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Component;
exports["default"] = _default;